module.exports = __webpack_public_path__ + "static/media/email2.ef48bf04.png";